import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import {
    _getKey,
    addImageSuffix,
    convertDateTimeToLocal,
    getUserInfo,
    parseHtml
} from '../../helpers/Util'
import Http from '../../helpers/Http'
import { SelectedFileViewComponent } from '../SelectedFileViewComponent'
import { closeLoader, openLoader } from '../../redux_toolkit/Loader'
import { toast } from 'react-toastify'
import Image from '../Image'

class SampleReply extends Component {
    constructor(props) {
        super(props)
        this.state = {
            post: this.props.post,
            showSingleReply: true,
            enableReplyOption: false,
            comment: '',
            selectedFiles: [],
            orderMemberList: this.props.orderMemberList
                ? this.props.orderMemberList
                : []
        }
        this.reactQuillRef = React.createRef(null)
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.orderMemberList !== prevProps.orderMemberList) {
            this.setState({
                orderMemberList: this.props.orderMemberList
            })
        }
        if (this.state.comment.length === 0) {
            this.mentionedUserInfoSet()
        } else {
            this.setSelectionForFocus()
        }
    }

    mentionedUserInfoSet = () => {
        const { mentionedUserIds, postedBy } = this.props.post
        if (mentionedUserIds?.includes(getUserInfo().id)) {
            if (Object.keys(postedBy).length > 0) {
                this.setState(
                    {
                        comment:
                            '<span class="mention" data-index="1" data-denotation-char="@" data-id=' +
                            postedBy?.email +
                            ' data-value=' +
                            postedBy?.name +
                            '>﻿<span contenteditable="false"><span class="ql-mention-denotation-char">@</span>' +
                            postedBy?.name +
                            '</span>﻿</span>'
                    },
                    () => {
                        this.setSelectionForFocus()
                    }
                )
            }
        }
    }
    setSelectionForFocus = () => {
        if (this.reactQuillRef.current && this.state.comment.length > 0) {
            this.reactQuillRef.current.editor.setSelection(
                this.state.comment.length + 2
            )
            this.reactQuillRef.current.focus()
        }
    }

    mentionModule = {
        allowedChars: /^[A-Za-z\s]*$/,
        mentionDenotationChars: ['@'],
        source: async (searchTerm, renderList, mentionChar) => {
            let values
            let { orderMemberList } = this.state
            if (mentionChar === '@') {
                values = orderMemberList.map((user) => {
                    return {
                        id: user.email,
                        value: user.name
                    }
                })
            } else {
                values = orderMemberList.map((user) => {
                    return {
                        id: user.email,
                        value: user.name
                    }
                })
            }

            if (searchTerm.length === 0) {
                renderList(values, searchTerm)
            } else {
                let matches = []
                values.filter((item, idx) => {
                    if (
                        item.value
                            ?.toLowerCase()
                            .includes(searchTerm.toLocaleLowerCase())
                    ) {
                        matches.push(values[idx])
                    }
                })

                renderList(matches, searchTerm)
            }
        }
    }

    filterComments = (comments) => {
        let { showSingleReply } = this.state
        if (showSingleReply && comments.length) {
            return [comments[0]]
        }
        return comments
    }

    onChange = (val) => {
        this.setState({
            comment: val
        })
    }

    onMultipleFileSelect = async (e, docType) => {
        let { selectedFiles } = this.state
        let files = Array.from(e.target.files)
        let key = e.target.name
        files.map((item) => {
            let data = {
                name: item.name,
                docMimeType: item.type,
                documentType: docType,
                print: false,
                base64Str: ''
            }
            let reader = new FileReader()
            reader.readAsDataURL(item)
            reader.onload = () => {
                data.base64Str = reader.result
                selectedFiles.push(data)
                this.setState({ selectedFiles })
            }
        })
    }

    removeFile = (index) => {
        let { selectedFiles } = this.state
        this.setState({
            selectedFiles: selectedFiles.filter((file, i) => i !== index)
        })
    }

    getMentionedUserIds = () => {
        let { comment, orderMemberList } = this.state
        let foundEmails = []
        let emailRegex =
            /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/
        let gotcha
        let match = null
        let ids = []
        while ((match = emailRegex.exec(comment))) {
            foundEmails.push(match[0])
            comment = comment.replace(match[0], '')
        }
        foundEmails.map((email) => {
            orderMemberList.map((member) => {
                if (member.email === email && !ids.includes(member.id)) {
                    ids.push(member.id)
                }
            })
        })
        return ids
    }

    submitComment = async () => {
        const { selectedFiles, comment, post } = this.state
        const { commentSubmitUrl, commentSubmitparam, commentFrom } = this.props
        let prevData = JSON.parse(JSON.stringify(post))
        await this.props.openLoader()
        const body = {
            documentDTOList: selectedFiles,
            postId: post.id,
            postType: 'COMMENT',
            // eslint-disable-next-line quotes
            text: comment.replace(/"/g, "'"),
            taggedUserIdList: this.getMentionedUserIds()
        }
        await Http.POST(
            commentSubmitUrl || 'addNewConversationComment',
            body,
            commentSubmitparam || ''
        )
            .then(({ data }) => {
                this.props.closeLoader()
                if (data.success) {
                    if (commentFrom === 'ORDER') {
                        prevData.commentList.push(data.payload.postResponse)
                        this.props.addNewReply(data.payload)
                    } else {
                        prevData.commentList.push(data.payload)
                    }
                    this.setState({
                        comment: '',
                        selectedFiles: [],
                        post: prevData
                    })
                }
            })
            .catch(({ response }) => {
                this.props.closeLoader()
                if (response && response.data && response.data.message) {
                    toast.error(response.data.message)
                }
            })
    }

    recipients = {
        BUYER: <span className='buyer-sign px-1'>Ⓑ</span>,
        NITEX: <span className='nitex-sign px-1'>Ⓝ</span>
    }

    renderPostedTime = (post) => {
        return (
            <div className='time'>
                {convertDateTimeToLocal(
                    post?.postDate,
                    post?.postTime,
                    'h:mm A, Do MMM'
                )}
                {post?.recipients?.map((item) => (
                    <span key={`rece_${_getKey()}`}>
                        {this.recipients[item.recipientType]}
                    </span>
                ))}
            </div>
        )
    }

    renderPostTitleExt = (post) => {
        if (
            post.postType === 'TASK_APPROVE' ||
            post.postType === 'TASK_COMPLETE'
        ) {
            return (
                <>
                    <span className='mr-2' style={{ color: '#00C334' }}>
                        {post.completedAction}
                    </span>
                    {post?.completedActedUpon
                        ? post.completedActedUpon
                        : post?.stepMaterial?.materialName}
                </>
            )
        } else if (post.postType === 'TASK_PRODUCTION_QUANTITY_UPDATE') {
            return (
                <>
                    <span className='mr-2' style={{ color: '#6A7181' }}>
                        updated production quantity on
                    </span>
                    {post.deliverableName}
                </>
            )
        } else if (post.postType === 'TASK_REVISION') {
            return (
                <>
                    <span className='mr-2' style={{ color: '#F82B60' }}>
                        requested for revision
                    </span>
                    <span
                        style={{ color: 'rgba(0,0,0,.36)', marginRight: '4px' }}
                    >
                        {' '}
                        on{' '}
                    </span>{' '}
                    {post.deliverableName}
                </>
            )
        } else {
            return null
        }
    }

    render() {
        let {
            post,
            showSingleReply,
            comment,
            enableReplyOption,
            selectedFiles
        } = this.state
        // console.log(post, '----render');
        let postedBy = post.postedBy ? post.postedBy : {}
        let { userInfo } = this.props
        return (
            <>
                <div className='conversation'>
                    {this.props.commentType === 'SYSTEM_GENERATED' ? (
                        <>
                            <div className='conv-header'>
                                <Image src='/icons/bell.svg' />
                                {this.renderPostedTime(post)}
                            </div>
                            <div className='task-status'>
                                {this.renderPostTitleExt(post)}
                            </div>
                        </>
                    ) : (
                        <>
                            <div className='conv-header'>
                                {postedBy.imageUrl ? (
                                    <Image
                                        src={postedBy.imageUrl}
                                        alt=''
                                        isStatic={false}
                                    />
                                ) : (
                                    <Image
                                        src='/images/pro_pic_default.svg'
                                        alt=''
                                    />
                                )}
                                <div className='name'>
                                    {postedBy.name}{' '}
                                    {postedBy.designation && (
                                        <span className='tag'>
                                            {postedBy.userType === 'BUYER'
                                                ? 'Buyer'
                                                : postedBy.designation}
                                        </span>
                                    )}
                                </div>
                                {this.renderPostedTime(post)}
                            </div>
                            <div className='task-status'>
                                {this.renderPostTitleExt(post)}
                            </div>
                        </>
                    )}

                    <div className='messages'>
                        <div
                            className={`${
                                this.props.commentType === 'SYSTEM_GENERATED'
                                    ? 'auto-generated-comment'
                                    : ''
                            }`}
                            dangerouslySetInnerHTML={{
                                __html: parseHtml(post.text)
                            }}
                        />
                        {post.docList && post.docList.length ? (
                            <div className='files-n-photos custom-scrollbar open'>
                                {post.docList.map((file, i) => {
                                    return (
                                        <SelectedFileViewComponent
                                            showRemoveOption={false}
                                            file={file}
                                            key={i}
                                            index={i}
                                        />
                                    )
                                })}
                            </div>
                        ) : (
                            <></>
                        )}
                        {!enableReplyOption && (
                            <div className='reply-container'>
                                <button
                                    className='reply'
                                    onClick={() =>
                                        this.setState({
                                            enableReplyOption: true
                                        })
                                    }
                                >
                                    Reply
                                </button>
                                {this.props.isAllCommentsOn && (
                                    <span className='task-tag material ml-3'>
                                        {post?.deliverableName}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                <div className='conversation conv-reply'>
                    {this.filterComments(post.commentList).map((comment) => {
                        let commentPostedBy = comment?.postedBy
                            ? comment.postedBy
                            : {}
                        return (
                            <div key={`body_${_getKey()}`}>
                                <div className='conv-header'>
                                    {commentPostedBy.imageUrl ? (
                                        <Image
                                            src={commentPostedBy.imageUrl}
                                            alt=''
                                            isStatic={false}
                                        />
                                    ) : (
                                        <Image
                                            src='/images/pro_pic_default.svg'
                                            alt=''
                                        />
                                    )}
                                    <div className='name'>
                                        {commentPostedBy.name}{' '}
                                        {commentPostedBy.designation && (
                                            <span className='tag'>
                                                {commentPostedBy.designation}
                                            </span>
                                        )}
                                    </div>
                                    {this.renderPostedTime(comment)}
                                </div>
                                <div className='messages'>
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: parseHtml(comment.text)
                                        }}
                                    />
                                    {showSingleReply &&
                                        post.commentList.length > 1 && (
                                            <div className='reply-container'>
                                                <button
                                                    className='view-reply'
                                                    onClick={() =>
                                                        this.setState({
                                                            showSingleReply: false
                                                        })
                                                    }
                                                >
                                                    View{' '}
                                                    {post.commentList.length -
                                                        1}{' '}
                                                    replies
                                                </button>
                                            </div>
                                        )}
                                    {comment.docList &&
                                    comment.docList.length ? (
                                        <div className='files-n-photos custom-scrollbar open'>
                                            {comment.docList.map((file, i) => {
                                                return (
                                                    <SelectedFileViewComponent
                                                        showRemoveOption={false}
                                                        file={file}
                                                        key={i}
                                                        index={i}
                                                        remove={this.removeFile}
                                                    />
                                                )
                                            })}
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                    {enableReplyOption ? (
                        <div className='reply-option'>
                            <div className='user-photo'>
                                {userInfo && userInfo.profilePicDocument ? (
                                    <Image
                                        src={userInfo.profilePicDocument.docUrl}
                                        alt=''
                                        isStatic={false}
                                    />
                                ) : (
                                    <Image
                                        src='/images/pro_pic_default.png'
                                        alt=''
                                    />
                                )}
                            </div>
                            <ReactQuill
                                ref={this.reactQuillRef}
                                name='comment'
                                value={comment}
                                debug='info'
                                theme='bubble'
                                placeholder='Write reply…'
                                onChange={this.onChange}
                                modules={{ mention: this.mentionModule }}
                            />
                            <div
                                className={`files-n-photos custom-scrollbar ${
                                    selectedFiles.length ? 'open' : ''
                                }`}
                            >
                                {selectedFiles.map((file, i) => {
                                    return (
                                        <SelectedFileViewComponent
                                            showRemoveOption={true}
                                            file={file}
                                            key={i}
                                            index={i}
                                            remove={this.removeFile}
                                        />
                                    )
                                })}
                            </div>

                            <div className='post-actions'>
                                <div className='attachment cursor-pointer'>
                                    <label htmlFor='input-file-reply'>
                                        <svg
                                            width='24'
                                            height='24'
                                            viewBox='0 0 24 24'
                                            fill='none'
                                            xmlns='http://www.w3.org/2000/svg'
                                        >
                                            <path
                                                d='M12.5 22C9.46 22 7 19.54 7 16.5L7 6C7 3.79 8.79 2 11 2C13.21 2 15 3.79 15 6L15 14.5C15 15.88 13.88 17 12.5 17C11.12 17 10 15.88 10 14.5L10 7L12 7L12 14.59C12 15.14 13 15.14 13 14.59L13 6C13 4.9 12.1 4 11 4C9.9 4 9 4.9 9 6L9 16.5C9 18.43 10.57 20 12.5 20C14.43 20 16 18.43 16 16.5L16 7L18 7L18 16.5C18 19.54 15.54 22 12.5 22Z'
                                                fill='#595959'
                                            ></path>
                                        </svg>
                                    </label>
                                    <input
                                        id='input-file-reply'
                                        type='file'
                                        name='selectedFiles'
                                        onChange={(e) =>
                                            this.onMultipleFileSelect(
                                                e,
                                                'ACCESSORIES_DESIGN'
                                            )
                                        }
                                        multiple
                                        onClick={(e) => (e.target.value = null)}
                                    />
                                </div>
                                <div className='save-note !mt-1'>
                                    <button
                                        className='text-sm blue mr-3'
                                        onClick={this.submitComment}
                                        disabled={!comment.length}
                                    >
                                        Reply
                                    </button>
                                    <div
                                        className='close-note cursor-pointer'
                                        onClick={() =>
                                            this.setState({
                                                comment: '',
                                                selectedFiles: [],
                                                enableReplyOption: false
                                            })
                                        }
                                    >
                                        <svg
                                            width='14'
                                            height='15'
                                            viewBox='0 0 14 15'
                                            fill='none'
                                            xmlns='http://www.w3.org/2000/svg'
                                        >
                                            <path
                                                d='M14 1.91L12.59 0.5L7 6.09L1.41 0.5L0 1.91L5.59 7.5L0 13.09L1.41 14.5L7 8.91L12.59 14.5L14 13.09L8.41 7.5L14 1.91Z'
                                                fill='#222222'
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            </>
        )
    }
}

// const getMinsCountFromNow = (dateTime, format) => {
// 	let res = moment().diff(moment.utc(dateTime, format));
// 	if (res) {
// 		return parseInt(res / (1000 * 60));
// 	}
// 	return 0;
// };

// const getTimeCount = (mins) => {
// 	if (mins < 60) {
// 		return `${mins} m`;
// 	}

// 	let hrs = parseInt(mins / 60);

// 	if (hrs < 24) {
// 		return `${hrs}h`;
// 	} else if (hrs < 24 * 7) {
// 		return `${parseInt(hrs / 24)}d`;
// 	} else {
// 		return `${parseInt(hrs / (24 * 7))}w`;
// 	}
// };

const mapStateToProps = (store) => ({})

export default connect(mapStateToProps, { closeLoader, openLoader })(
    SampleReply
)
